export const chipTheme = {
    list: {
        spacing: (props) => props.theme.spacing.xxs,
    },
    radius: (props) => props.theme.radius.xl,
    rightSlotSpacing: (props) => props.theme.spacing.xs,
    leftSlotSpacing: (props) => props.theme.spacing.xxs,
    // sizes
    md: {
        typographySize: 'xs',
        padding: {
            vertical: (props) => props.theme.spacing.xxs,
            horizontal: (props) => props.theme.spacing.xs,
        },
    },
    sm: {
        typographySize: 'xxs',
        padding: {
            vertical: '0.188rem',
            horizontal: (props) => props.theme.spacing.xs,
        },
    },
    xxs: {
        typographySize: 'xxs',
        padding: {
            vertical: '0.063rem',
            horizontal: (props) => props.theme.spacing.xs,
        },
    },
    selectable: {
        border: {
            width: '1px',
            color: (props) => props.theme.palette.secondary,
        },
        background: {
            color: {
                unselected: (props) => props.theme.palette.surface,
            },
        },
    },
};
export const chipSizeVariant = ({ size }) => chipTheme[size];
